<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2>データ入出力</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-tabs
            vertical
          >
            <v-tab
              v-for="item in items"
              :key="item.tab"
            >
              <v-icon left>
                {{ item.icon }}
              </v-icon>
              {{ item.name }}
            </v-tab>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <vehicle-layout />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <user-layout />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <emission-layout />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <emission-location-layout />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import VehicleLayout from './layouts/_Vehicle'
import UserLayout from './layouts/_User'
import EmissionLayout from './layouts/_Emission'
import EmissionLocationLayout from './layouts/_EmissionLocation'
export default {
  name: 'DriverImportIndex',
  components: {
    VehicleLayout,
    UserLayout,
    EmissionLayout,
    EmissionLocationLayout,
  },
  mixins: [],
  props: {},
  data() {
    return {
      selectedTab: 'vehicles',
      items: [
        {
          tab: 'vehicles',
          icon: 'mdi-truck',
          name: '車両',
        },
        {
          tab: 'users',
          icon: 'mdi-account-outline',
          name: 'ユーザ',
        },
        {
          tab: 'emissions',
          icon: 'mdi-bank',
          name: '排出事業者',
        },
        {
          tab: 'emission_locations',
          icon: 'mdi-sitemap-outline',
          name: '排出事業場',
        },
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.v-tab {
  min-width: 200px;

  &.v-tab {
    justify-content: start;
  }

}
</style>
